<template>
  <app-layout>
    <template #header>
      <AppHead title="Account Billing" />
      <div class="row py-2">
        <div class="col-12 col-md-6 col-lg-8 d-flex align-items-center">
          <h2 class="title">Account Billing</h2> 
        </div>
      </div>
      <flash-messages />
    </template>

    <div class="mt-4">
      <ul class="nav nav-tabs nav-justified">
        <li class="nav-item">
          <inertia-link :class="tab == 'charges' ? 'nav-link active' : 'nav-link'" :href="route('mtd.billing', 'charges')">Charges</inertia-link>
        </li>
        <li class="nav-item">
          <inertia-link :class="tab == 'payments' ? 'nav-link active' : 'nav-link'" :href="route('mtd.billing', 'payments')">Payments</inertia-link>
        </li>
      </ul>
      <card class="border-top-0">
        <div class="tab-content" id="transactions_content">
          <div class="tab-pane fade show active pt-3 clearfix" v-if="tab == 'charges'">
            <div v-if="payment.unpaidTotal > 0">
                <MTDPayment :payment="payment"/>
            </div>
            <div v-else>
              <h3 class="card-title m-0">Account Balance: {{ (payment.unpaidTotal < 0 ? '-$' : '$') + formatCurrency(Math.abs(payment.unpaidTotal)) }}</h3>
              <br/>
            </div>

            <ChargesTable />
          </div>

          <div class="tab-pane fade show active pt-3 clearfix" v-if="tab == 'payments'">
            <Payments :payments="payments" />
          </div>

        </div>
      </card>
    </div>
  </app-layout>
</template>

<script>
  import AppLayout from '@/Layouts/AppLayout'
  import FlashMessages from '@/Shared/FlashMessages'

  import JetInput from '@/Jetstream/Input'
  import JetCheckbox from '@/Jetstream/Checkbox'
  import JetInputError from '@/Jetstream/InputError'
  import JetLabel from '@/Jetstream/Label'
  import Icon from '@/Shared/Icon'

  import TransactionTabs from '@/Components/Nav/TransactionTabs'

  import MTDPayment from '@/Components/Payment/MTDPayment'
  import ChargesTable from '@/Components/Transaction/ChargesTable'
  import Payments from '@/Components/Transaction/Payments'
  
  export default {
    components: {
      AppLayout,
      FlashMessages,
      JetInput,
      JetCheckbox,
      JetInputError,
      JetLabel,
      Icon,
      TransactionTabs,
      MTDPayment,
      ChargesTable,
      Payments,
    },
    props: {
      tab: String,
      has_linked: Boolean,
      is_linked: Boolean,
      current: Boolean,
      monthText: String,
      month: Number,
      year: Number,
      months: Array,
      payment: Object,
      charges: Array,
      payments: Array,
    },
    data() {
      return {
      }
    }
  }
</script>
